<template>
  <div class="star" @mouseleave="deblocked">
    <span
      :class="{ score: score <= value }"
      v-for="(score, index) in scores"
      @mouseover="over(score)"
      @mouseout="out"
      :disabled="disabled"
      v-on:click="set(score)"
    ><icon class="fa-xs" :icon="['fad', 'star']"/></span>
    <div class="d-inline-flex ml-1 smaller" style="width: 110px;">  Rating:{{value}} ({{ratings[poster].count}} votes)</div>
  </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        props: [
            'poster',
        ],
        data() {
            return {
                scores: [1, 2, 3, 4, 5],
                temp: 0,
                disabled: false,
            }
        },
        computed: {
            ...mapState(
                ['ratings']
            ),
            value: {
                get: function () {
                    return this.$store.state.ratings[this.poster].rating;
                },
                set(value) {
                    return this.$store.commit('setStarRating', {id: this.poster, value: value});
                }
            }
        },
        methods: {
            over(score) {
                if (this.disabled) {
                    return;
                }
                this.temp = this.value;
                this.value = score;
            },
            out() {
                if (this.disabled) {
                    return;
                }
                this.value = this.temp;
            },
            deblocked() {
                this.disabled = false;
            },
            set(value) {
                if (this.disabled) {
                    return;
                }
                this.disabled = true;
                let rating = {poster_id: this.poster, rating: value};
                this.$store.dispatch('SET_RATING', rating);
            }
        }
    }
</script>

<style lang="scss">
  .star span {
    list-style: none;
    color: #a8a8a8;
    cursor: pointer;
  }

  .star span.score {
    color: #ffaa00;
  }
</style>
